import React from "react";
import { Select } from "antd";

const SelectOption = ({
  placeholder,
  options = [],
  className = "",
  value,
  onChange,
  ...props
}) => {
  return (
    <div
      className={`
        bg-gray-50 rounded-lg h-9 flex items-center
        ${className}
      `}
    >
      <Select
        placeholder={placeholder}
        variant="borderless"
        options={options}
        value={value}
        onChange={onChange}
        allowClear
        listHeight={options.length * 32}
        className="w-full text-[14px]"
        {...props}
      />
    </div>
  );
};

export default SelectOption;
